import { Box, Typography, Tooltip } from '@mui/material';
import { AvatarSize, Route } from 'app/enums';
import { UserEntity } from 'app/interfaces/entity';
import React, { FC, ReactElement, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { HumanizeOrdinalFormat } from 'shared/components/Format/HumanizeOrdinalFormat';
import { ValueOrDefaultFormat } from 'shared/components/Format/ValueOrDefaultFormat';
import { UserAvatar } from 'shared/components/UserAvatar';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import { useStyles } from './LeaderboardCard.styles';

interface LeaderboardCardProps {
  title: string;
  value: number | string | ReactElement;
  rank?: number;
  user: Partial<UserEntity>;
  gameIcon?: string;
  gameTitle?: string;
}

export const LeaderboardCard: FC<LeaderboardCardProps> = ({
  title,
  gameIcon,
  gameTitle = '',
  user,
  value,
  rank,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const onClickHandler = useCallback(() => {
    if (!user) {
      return;
    }

    navigate(`${Route.Players}/${user.id}`);
  }, [user, navigate]);

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>{title}</Typography>
      <Box className={classes.content}>
        <Box display="flex">
          <Box className={classes.icon}>
            <Tooltip title={gameTitle}>
              <img src={gameIcon} alt="game-icon" />
            </Tooltip>
          </Box>
          <Tooltip
            title={
              <Typography>
                <HumanizeOrdinalFormat order={rank} /> rank
              </Typography>
            }
          >
            <Box className={classes.rankContainer}>
              <Typography className={classes.rank}>
                <ValueOrDefaultFormat value={rank} />
              </Typography>
              <MilitaryTechIcon className={classes.rankIcon} />
            </Box>
          </Tooltip>
          <Box className={classes.user} onClick={onClickHandler}>
            <UserAvatar user={user} size={AvatarSize.Medium} />
            <Box className={classes.userValueContainer}>
              <Typography className={classes.username}>{user.userName}</Typography>
            </Box>
          </Box>
        </Box>
        <Typography className={classes.value}>{value}</Typography>
      </Box>
    </Box>
  );
};
